export default {
	loading: false,
	codes  : []
}
